var exports = {
  "kL": "x7be19a29--33e225--container",
  "R": "x7be19a29--33e225--hidden",
  "Qs": "x7be19a29--33e225--content",
  "kb": "x7be19a29--33e225--left",
  "iW": "x7be19a29--33e225--main",
  "z": "x7be19a29--33e225--summary",
  "pG": "x7be19a29--33e225--right",
};

module.exports = exports;
